import { ToPersian } from "./changeNumber";
import ToEnglish from "./persianNumberToEnglish";

// export const sort = (data, ascending, key) => {
//   try {
//     let tmp = ascending ? -1 : 1;
//     return data.sort((obj1, obj2) => {
//       if (obj1[key] < obj2[key]) {
//         return tmp;
//       }
//       if (obj1[key] > obj2[key]) {
//         return -1 * tmp;
//       }
//       // keys must be equal
//       return 0;
//     });
//   } catch (e) {
//     console.log(e);
//     return data;
//   }
// };

export const sort = (array, ascending, key) => {
  let tmp = ascending ? 1 : -1;
  return array.sort(
    (a, b) =>
      ToEnglish(a[key]).localeCompare(ToEnglish(b[key]), undefined, {
        sensitivity: "base"
      }) * tmp
  );
};

export const sortBy2Property = (array, ascending, nonStringKey, stringKey) => {
  let tmp = ascending ? 1 : -1;
  return array.sort((a, b) => {
    if (a[nonStringKey] < b[nonStringKey]) {
      return -1 * tmp;
    } else if (a[nonStringKey] > b[nonStringKey]) {
      return 1 * tmp;
    } else {
      return (
        ToEnglish(a[stringKey]).localeCompare(
          ToEnglish(b[stringKey]),
          undefined,
          { sensitivity: "base" }
        ) * tmp
      );
    }
  });
};

export const normalizedText = item => {
  let normalizedItem = ToPersian(item);
  normalizedItem = normalizedItem.replace("ي", "ی");
  normalizedItem = normalizedItem.replace("ك", "ک");
  normalizedItem = normalizedItem.replace("٤", "۴");
  normalizedItem = normalizedItem.replace("٦", "۶");
  return normalizedItem;
};

export const search = (data, query, searchKeys) => {
  try {
    return data.filter(
      item =>
        !query ||
        searchKeys.filter(
          key =>
            item[key] &&
            normalizedText(item[key]).indexOf(normalizedText(query)) !== -1
        ).length > 0
    );
  } catch (e) {
    console.log(e);
    return data;
  }
};
